export default __webpack_public_path__ + "static/media/thunder.bcae53a7.jpg";